import sideImage from "../images/afro-solar/solution-for-industrials/Solutions for INDUSTRIAL Business Opportunities.webp";

const industrialsSolutions = [
  {
    title: "Reduced Utility Expenditure",
    description:
      "Reduced utility bills with locked-in rates that will always be cheaper than the grid.",
  },
  {
    title: "Reduced Carbon Footprint ",
    description:
      "Every megawatt installed lowers your carbon footprint by 25,000 tons.",
  },
  {
    title: "Increased Renewable Energy",
    description:
      "Generation of clean, green energy that can contribute to improved levels of air quality.",
  },
  {
    title: "No upfront costs,",
    description:
      "​no financial burden; we take over from A-Z. We design, secure funds, install and maintain system.​",
  },
  {
    title: "Make a difference",
    description:
      "Support sustainability strategy and renewable energy development for your organization.  ",
  },
  {
    title: "Develop Energy Business",
    description:
      "Simply pay for the power you consume, at a locked-in rate that will always be cheaper than the grid.",
  },
];

const IndustrialSolution = () => {
  return (
    <div className="container-fluid pt-7">
      <div className="me-13 ms-13 pt-7">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 my-auto order-1 order-lg-0">
            {industrialsSolutions.map((solution, index) => (
              <div className="row" key={solution.title}>
                <h2
                  className="col-2 text-24 gilroy-bold bg-american-yellow text-center me-4"
                  style={{
                    height: "40px",
                    width: "40px",
                    borderRadius: "50%",
                    lineHeight: "40px",
                  }}
                >
                  {index + 1}
                </h2>
                <div className="col-10">
                  <h3 className="fs-18 gilroy-bold">{solution.title}</h3>
                  <p className="fs-16">{solution.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="col-12 col-md-12 col-lg-6 text-center order-0 order-lg-1 mb-5 mb-lg-0">
            <img
              src={sideImage}
              alt="solution for industrial"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustrialSolution;
